export default __webpack_public_path__ + "static/media/placeholder.95475ba8.gif";